import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { i18n } from "./_locales/TranslationConfig";
import RolesHelper from "@/_helpers/RolesHelper";
import ModesHelper from "@/_helpers/ModesHelper";

import RealmTracker from "./_helpers/RealmTracker";
import AuthenticationHelper from "@supervision/vue-components/_helpers/Authentication";
import store from "@/_stores/authStore";

import "bootstrap/dist/css/bootstrap.min.css";
import "@supervision/vue-components/fonts/fonts.css";

const app = createApp(App);
app.config.unwrapInjectedRef = true;

router.afterEach((to) => {
  localStorage.setItem("latest_visitied", to.fullPath);
});

router.beforeEach((to, from, next) => {
  to.fullPath = to.fullPath.replace(to.hash, "");
  if (to.path == "/") {
    router.replace({ name: "amrHome" });
    return;
  }
  if (from.name == "loading" && to.name == "amrHome") {
    router.go(-1);
    return;
  }
  if (!to.meta.roles || to.meta.roles.includes("guest")) return next();
  if (
    !RolesHelper.hasAtLeastOneRole(
      app.config.globalProperties.$keycloak.tokenParsed.role,
      to.meta.roles
    )
  ) {
    router.replace({
      name: "error",
      params: { code: 401 },
    });
    return;
  }
  if (from?.name?.includes("manageClients") && from?.name !== to?.name) {
    const routeChangeEvent = new CustomEvent("amr-route-change", {
      detail: {
        to,
        from,
        next,
      },
    });
    window.dispatchEvent(routeChangeEvent);
    return;
  }
  return next();
});

ModesHelper.IsDeviceManagerMode().then((isDmApiMode) => {
  app.config.globalProperties.$isDmApiMode = isDmApiMode;
  store.dispatch("initializeKeycloak", app);

  app
    .use(RealmTracker)
    .use(store)
    .use(AuthenticationHelper)
    .use(i18n)
    .use(router);
});
